import { memo } from 'react';

const RiskMsgResult = () => {
  return (
    <section className={'w-full'}>
      <div className="my-[71px] flex justify-center">
        <div className="mr-[28px] h-[82px] w-[109px]">
          <img className="w-full" src="https://static.szlcsc.com/ecp/assets/newWeb/so/empty.png" alt="没有找到商品" />
        </div>
        <div className="ttext-[#444]">
          <p className="mb-[6px]  text-[14px]">您的输入内容中包含敏感词，请在修改后重新搜索</p>
        </div>
      </div>
    </section>
  );
};

export default memo(RiskMsgResult);
